export default __webpack_public_path__ + "static/media/Frame 10.2c00ba40.svg";